var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgForm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 21,
  height: 23,
  viewBox: "0 0 21 23"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "form_svg__a",
  d: "M2.333 0C1.05 0 0 1.11 0 2.463v17.24c0 1.354 1.05 2.464 2.333 2.464h16.333c1.284 0 2.334-1.11 2.334-2.464V2.463C21 1.11 19.95 0 18.666 0zm5.834 7.389h8.166V4.926H8.167zm-3.5 0h2.332V4.926H4.667zm3.5 4.927h8.166V9.852H8.167zm-3.5 0h2.332V9.852H4.667zm3.5 4.925h8.166v-2.463H8.167zm-3.5 0h2.332v-2.463H4.667z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "form_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#form_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#464543",
  d: "M-5.833 28h32.666V-5.833H-5.833z",
  mask: "url(#form_svg__b)"
}))));
export default SvgForm;